import React, { Fragment } from 'react';
import loadable from '@loadable/component';

import FatwasList from '../FatwasList';

const AnnouncementList = loadable(() => import(/* webpackChunkName: "announcements-list" */ '../AnnouncementList'));

const Home = props => (
    <Fragment>
        <AnnouncementList {...props} />
        <FatwasList {...props} />
    </Fragment>
);

export default Home;
